<template>
  <div class="size-full bg-(--p-surface-200) dark:bg-(--p-surface-700)">
    <img
      :src="src"
      :alt="title"
      :aria-label="title"
      :fetchpriority="fetchpriority"
      :class="['w-full h-full object-cover', showImage ? 'opacity-100' : 'opacity-0']"
      @load="onImgLoad"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import { useImageReady } from '@/composables/useImageReady';

const props = withDefaults(
  defineProps<{
    title: string;
    src: string;
    fetchpriority?: 'high' | 'low' | 'auto';
  }>(),
  { fetchpriority: 'auto' },
);

const emit = defineEmits<{
  load: [];
}>();

const imgLoaded = ref(false);
const preloaded = useImageReady(() => props.src);

const showImage = computed(() => preloaded.value || imgLoaded.value);

const onImgLoad = () => {
  imgLoaded.value = true;
  emit('load');
};

watch(
  () => props.src,
  () => {
    imgLoaded.value = false;
  },
);
</script>
